import {
  PECriminalHistoriesCardActions, PECriminalHistoriesCardGetters, PECriminalHistoriesCardMutations,
} from './pe-criminal-histories-card'
import {
  PEDetentionHistoriesCardActions, PEDetentionHistoriesCardGetters, PEDetentionHistoriesCardMutations,
} from './pe-detention-histories-card'
import {
  PEEducationHistoriesCardActions, PEEducationHistoriesCardGetters, PEEducationHistoriesCardMutations,
} from './pe-educational-histories-card'
import {
  PEJobHistoriesCardActions, PEJobHistoriesCardGetters, PEJobHistoriesCardMutations,
} from './pe-job-histories-card'
import {
  PEResidenceHistoriesCardActions, PEResidenceHistoriesCardGetters, PEResidenceHistoriesCardMutations,
} from './pe-residence-histories-card'

export const HistorySectionActions = {
  ...PECriminalHistoriesCardActions,
  ...PEDetentionHistoriesCardActions,
  ...PEEducationHistoriesCardActions,
  ...PEJobHistoriesCardActions,
  ...PEResidenceHistoriesCardActions,
}

export const HistorySectionGetters = {
  ...PECriminalHistoriesCardGetters,
  ...PEDetentionHistoriesCardGetters,
  ...PEEducationHistoriesCardGetters,
  ...PEJobHistoriesCardGetters,
  ...PEResidenceHistoriesCardGetters,
}

export const HistorySectionMutations = {
  ...PECriminalHistoriesCardMutations,
  ...PEDetentionHistoriesCardMutations,
  ...PEEducationHistoriesCardMutations,
  ...PEJobHistoriesCardMutations,
  ...PEResidenceHistoriesCardMutations,
}
